import { heroUrl } from "../../lib/api";
import { QrMatrix, useQrCode } from "../QrMatrix";

// Gift-box sticker: nothing but a big scannable code to this duck's spinning viewer. Sized like the passport card
// (105 x 148 mm) so PassportSheet can scale it onto a Rollo 4x6" label. Default is thermal-safe black & white;
// `colour` adds the brand yellow band for colour label stock.
export const QrStickerCard = ({ duck, height, colour = false }) => {
  const name = duck.name || duck.story?.name || "Your Duckify3D duck";
  const qr = useQrCode(duck.id);

  return (
    <article
      data-testid="qr-sticker-card"
      className="print-exact relative bg-white text-[#121417] overflow-hidden flex flex-col items-center text-center"
      style={{ width: "105mm", height: "148mm", padding: colour ? "0 0 7mm" : "7mm 6mm", gap: "4mm", fontFamily: "Outfit, sans-serif" }}
    >
      {colour ? (
        <div className="w-full grid place-items-center" style={{ height: "16mm", background: "#FFC700", marginBottom: "3mm" }}>
          <p className="font-bold text-[12pt] tracking-tight" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
            DUCKIFY<span className="text-[#E8590C]">3D</span>
          </p>
        </div>
      ) : (
        <p className="font-mono2 uppercase tracking-[0.3em] text-[7pt]">Duckify3D</p>
      )}
      <h1 data-testid="qr-sticker-name" className="font-bold leading-[1.05] text-[15pt] tracking-tight line-clamp-2" style={{ fontFamily: "Space Grotesk, sans-serif", padding: "0 8mm" }}>
        {name}
      </h1>
      <div className="bg-white p-[2mm]" style={{ border: "0.5mm solid #121417", borderRadius: "2mm" }}>
        <QrMatrix testid="qr-sticker-qr" qr={qr} size="60mm" />
      </div>
      <p data-testid="qr-sticker-caption" className="font-bold text-[11pt] leading-tight" style={{ fontFamily: "Space Grotesk, sans-serif", padding: "0 6mm" }}>
        Scan me — spin, download, reorder
      </p>
      <div className="mt-auto flex items-center justify-center w-full" style={{ gap: "3mm", padding: "0 6mm" }}>
        <img src={duck.build_status === "ready" ? heroUrl(duck.id) : duck.render} alt="" className="shrink-0 object-cover" style={{ width: "18mm", height: "18mm", borderRadius: "2mm", filter: colour ? "none" : "grayscale(1) contrast(1.35)" }} />
        <div className="min-w-0 text-left">
          <p className="font-semibold text-[7.5pt] leading-tight">{height} mm · printed by Zero Ducks Given</p>
          <p data-testid="qr-sticker-url" className="text-[5.5pt] font-mono2 break-all leading-tight mt-[0.6mm]">{qr?.url || ""}</p>
        </div>
        <img src="/zdg-logo.png" alt="" className="shrink-0 object-contain" style={{ height: "9mm" }} />
      </div>
    </article>
  );
};
